import { get, patch, post, put, deleted } from "../index";
import AdleakRoutes from "./Adleaks.routes";

const AdleaksServices = {
  getAllAdLeaks: async (catId, search, page, limit, type, isApproved) => {

    let params = `?page=${page}&limit=${limit}&type=${type}`;
    if (catId) params += `&category=${catId}`
    if (search) params += `&title=${search}`
    if (isApproved != "") params += `&isApproved=${isApproved}`

    const result = await get(AdleakRoutes.getAllAdleaks + params);
    return result;
  },

  createAdLeaks: async (obj) => {
    const result = await post(AdleakRoutes.createAdLeaks, obj);
    return result;
  },

  updateAdLeaks: async (id, obj) => {
    const result = await put(AdleakRoutes.updateAdLeaks + `/${id}`, obj);
    return result;
  },

  approveBlog: async (id, obj) => {
    const result = await patch(AdleakRoutes.approveBlog + `/${id}`, obj);
    return result;
  },

  deleteBlog: async (id) => {
    const result = await deleted(AdleakRoutes.deleteBlog + `/${id}`);
    return result;
  }
}

export default AdleaksServices;